import axios from 'axios'

export default {
  getQuotes ( params, callback ) {
    axios.get('/quotes', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  getQuote ( quoteId, callback, fallback ) {
    axios.get('/quotes/' + quoteId)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  create ( data, callback, fallback ) {
    axios.post( '/quotes', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  save ( quoteId, data, callback, fallback ) {
    axios.post( '/quotes/' + quoteId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  approve ( quoteId, data, callback, fallback ) {
    axios.post( '/quotes/' + quoteId + '/approve', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  clone ( data, callback, fallback ) {
    axios.post( '/quotes/' + data.id + '/clone', data)
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( quoteId, callback, fallback ) {
    axios.delete( '/quotes/' + quoteId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  getItems ( quoteId, params, callback ) {
    axios.get('/quotes/' + quoteId + '/items', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
  createItem ( quoteId, data, callback, fallback ) {
    axios.post( '/quotes/' + quoteId + '/items', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  saveItem ( quoteId, itemId, data, callback, fallback ) {
    axios.post( '/quotes/' + quoteId + '/items/' + itemId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  deleteItem ( quoteId, itemId, callback, fallback ) {
    axios.delete( '/quotes/' + quoteId + '/items/' + itemId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  downloadPDF ( quoteId, params, callback, fallback ) {
    let query = params ? new URLSearchParams(params).toString() : null;
    axios({
      url: '/quotes/' + quoteId + '/pdf' + (query ? '?' + query : ''),
      method: 'GET',
      responseType: 'blob', // important
    }).then(resp => {
      callback( resp );
    }).catch(error => {
      fallback(error);
    });
  },
  printWIP ( params, callback, fallback ) {
    axios.get('/quotes/wip', {
      responseType: 'blob', // important
      params
    }).then(resp => {
      callback( resp );
    }).catch(error => {
      fallback(error);
    });
  },
  getQuoteAmount ( quoteId, params, callback ) {
    axios.get('/quotes/' + quoteId + '/amount', { params })
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(() => {});
  },
}
